import { pathOr } from 'ramda'

const DAYS = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday'
]

const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
]

function getOffsetString(offsetInHours) {
  if (!offsetInHours) return 'GMT'

  return `GMT${offsetInHours > 0 ? '-' : '+'}${Math.abs(offsetInHours)}`
}

export function getParsedDateString(dateStr, forceUtc = false) {
  const parsedDateStr = parseRawDateString(dateStr)

  let OFFSET_IN_HOURS, OFFSET_IN_MILLISECONDS

  if (process.server || forceUtc) {
    OFFSET_IN_HOURS = 0
    OFFSET_IN_MILLISECONDS = 0
  } else {
    /** Show time in user local timezone **/
    const OFFSET_IN_MINUTES = new Date().getTimezoneOffset()
    OFFSET_IN_HOURS = OFFSET_IN_MINUTES / 60
    OFFSET_IN_MILLISECONDS = OFFSET_IN_MINUTES * 60 * 1000
  }

  const date = new Date(parsedDateStr)
  date.setTime(date.getTime() - OFFSET_IN_MILLISECONDS)
  const day = date.getDate()
  const month = date.getMonth()
  const hours = date.getHours()
  const minutes = date.getMinutes()
  const seconds = date.getSeconds()

  const EEEE = DAYS[date.getDay()]
  const MM = addLeadingZero(month + 1)
  const yyyy = date.getFullYear()
  const dd = addLeadingZero(day)
  const d = day
  const HH = addLeadingZero(hours)
  const mm = addLeadingZero(minutes)
  const ss = addLeadingZero(seconds)
  const ZZZZ = getOffsetString(OFFSET_IN_HOURS)
  const MMMM = MONTHS[month]

  return {
    EEEE,
    MM,
    MMMM,
    yyyy,
    dd,
    d,
    HH,
    mm,
    ss,
    ZZZZ
  }

  function addLeadingZero(str) {
    return str < 10 ? `0${str}` : str
  }
}

function parseRawDateString(str) {
  return pathOr('0000-00-00T00:00:00.000', [], str).substring(0, 23)
}

/**
 * example of Page Scheme format: 2021-07-13T14:59:42+00:00
 */
export function rawDateUTCStringToPageSchemeFormat(str) {
  return `${parseRawDateString(str)}+00:00`
}
